import { consumeAuthFromHash } from '@core/utils/auth-from-hash'
import { startApp } from '@core/utils/start-app'
import i18n, { i18nInit } from '@discover/i18n/i18n'
import { router } from '@discover/router'
import { ROUTES } from '@discover/utils/router/paths'

import '@discover/index.css'

// Consume auth token from URL hash fragment (cross-app handoff from Platform)
consumeAuthFromHash()

startApp({
  router,
  i18n,
  i18nInit,
  sentryDsn: import.meta.env.VITE_DISCOVER_SENTRY_DSN,
  logOutPath: ROUTES.logOut,
  themeStorageKey: 'discover-ui-theme',
})
